module.exports = __webpack_public_path__ + "img/born.7f0eec62.svg";